//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Die.js";
import "../no/TaggedObject.js";
import "../no/SelectNXObject.js";
import "../no/ugmath.js";
import "../no/SelectObject.js";
let d=[[[0,"CoordinateSystemMatrix",1,0],[0,"CoordinateSystemOrigin",1,0],[0,"InputType",1,0],[0,"ReverseSourceDirection",1,0],[1,"SelectPlane",0,"SelectNXObject",0],[0,"SpecifyPlane",1,"Plane",0]],[[[],"Validate",{R_:{result:''}},0,0]],[]];
SPLM.Die.DiePlaneBuilder = class extends SPLM.TaggedObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Die.DiePlaneBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Die.DiePlaneBuilder.PlaneType = Object.freeze({
    "Selection" : "Selection", "Plane" : "Plane", "CoordinateSystem" : "CoordinateSystem"});

export default SPLM;